import { SubRoute } from '../types';

export const isPathActive = (
  pathname: string | null,
  routePath: string,
  subRoutes?: SubRoute[]
): boolean => {
  if (!pathname) return false;

  if (routePath === '/' && !subRoutes) return pathname === '/';

  if (pathname.startsWith(routePath)) {
    if (pathname === routePath && routePath !== '/') return true;
    if (routePath !== '/') return true;
    if (routePath === '/' && subRoutes) {
      return subRoutes.some((sub) => sub.path === pathname);
    }
  }

  if (subRoutes?.some((sub) => sub.path === pathname)) return true;

  return false;
};
